let $ = jQuery;

$(function () {
    function scrollUp() {
        let headerHeight = 0;
        if ($('#header-form').length) {
            headerHeight = $('#header-form').outerHeight();
        }

        $('html, body').animate({
            scrollTop: $(".review-listing").offset().top - headerHeight - 20
        }, 500);
    }

    // select the label rating and the label state when the values of the input change
    // then show the label 
    
    const handleChange = function () {
        var $label = $(this).closest('.filter-field').find('label');
        var $select = $(this);
        var $selectedOption = $select.find('option:selected');

        $label.removeClass('show-for-sr');
        $select.removeClass('selected');

        if ($selectedOption.is(':disabled')) {
            $label.addClass('show-for-sr');
        } else {
            $select.addClass('selected');
        }
    }

    $('.review-listing [name="rating"], .review-listing [name="state"]').on('change',handleChange);
    // review filters
    $('.review-listing [name="state"]').on('change', function () {
        $("#review-list")
            .data('resetHtml', true)
            .data('state', $(this).val())
            .data('page', 1);
        loadMore();
        scrollUp();
    });
    
    $('.review-listing [name="rating"]').on('change', function () {
        var filteredRating = $(this).val();
        $('.review-summary .summary-row').each(function () {
            let isZero = $(this).find(".count").text() == "0";
            if(!isZero) {
                $(this).prop("disabled", false);
            }
        });
        $('.review-summary .summary-row').removeClass('filtered');
        if (filteredRating != '')
        {
            let filteredElm = $('.review-summary .summary-row').eq(-1 * filteredRating);
            filteredElm.addClass('filtered');
            filteredElm.prop("disabled", true);
        }
        $("#review-list")
            .data('resetHtml', true)
            .data('rating', filteredRating)
            .data('page', 1);
        loadMore();
        scrollUp();
    });

    // clicking on summary rating rows changes the rating filter to match the clicked rating
    $('.review-summary .summary-row').on('click', function () {
        var index = $(this).index() + 1;
        var $opt = $('.review-listing [name="rating"] option').eq(index);
        $('.review-listing [name="rating"]').val($opt.prop('value'))
            .trigger('change');
    });

    // changes the pages in view depending on screen sizes
    // also takes into consideration if filtered
    $(window).on('resize', function() {
        $(".review-listing").each(function() {
            let $pageLIs =  $(this).find(".pagination li");
            let totalPages = $pageLIs.filter("li[style]:not([style^='display'])").last().find("a").attr("data-page");
            if(totalPages > 8) {
                $pageLIs.parent().elidePages(totalPages);
            }
        });
    });


    if (window.location.hash) {
        // there may be anchors in the URL for reviews that haven't been loaded
        // handle that here
        // TODO: make this work with pagination
        if (window.location.hash.startsWith('#review-')) {
            if ($(window.location.hash).length) { // review on this page, scroll to it
                let headerHeight = 0;
                if ($('#header-form').length) {
                    headerHeight = $('#header-form').outerHeight();
                }

                $('html, body').animate({
                    scrollTop: $(window.location.hash).offset().top - headerHeight - 20
                }, 900, 'swing');
            }
            else { // review not on this page
                loadMore(window.location.hash.replace('#review-', ''));
            }
        }
    }

    // too many page numbers? remove some and replace with ellipses
    $('.pagination').each(function () {
        if ($('li', this).length > 8) {
            $(this).elidePages();
        }
    });

    // go to page
    $('#review-pagination .pagination a:not(.ellip)').on('click', function (e) {
        e.preventDefault();

        // Removing and Adding selected-page class to make enable/disable on click
        $('#review-pagination li a').removeClass('active');
        $(this).addClass('active');

        // reset elided page numbers accounting for new active page
        if ($('#review-pagination .pagination li').length > 8 &&
            !$('#review-pagination .pagination .active').is(':visible')) {
            $('#review-pagination .pagination').elidePages();
        }

        // Load Requested Page
        var requestedPage = $(this).data('page');
        $('#review-list').data('resetHtml', true).data('page', requestedPage);
        //Load more for the current page
        loadMore();
        scrollUp();
    });

    //Prev and Next Button
    $('#review-pagination .next').click(function () {
        var $pagination = $(this).closest('.pagination');

        // get current tab
        var currentTab = $(".active", $pagination);
        // get the next tab, if there is one
        var newTab = currentTab.parent().next().find("a");
        // at the end, so go to the first one
        if (newTab.length === 0) {
            newTab = $("a", $pagination).first();
        }

        newTab.trigger('click');
    });

    $('#review-pagination .previous').click(function () {
        var $pagination = $(this).closest('.pagination');

        // get current tab
        var currentTab = $(".active", $pagination);
        // get the previous tab, if there is one
        var newTab = currentTab.parent().prev().find("a");
        // at the end, so go to the first one
        if (newTab.length === 0) {
            newTab = $("a", $pagination).last();
        }
        // if the previous tab is an ellipse clicking it will do nothing so get the next previous elm
        // which is a numbered tab
        if(newTab.hasClass("ellip")) {
            newTab = newTab.parent().prev().find("a");
        }
        newTab.trigger('click');
    });

    //Jump to page
    window.reviewJumper = $('#review-pagination .jump-to-page').detach();
    $('#review-pagination .pagination').on('click', '.el-li a', function (e) {
        e.stopPropagation();
        $(this).after(window.reviewJumper);
    });
    // close jumper when clicking outside of it
    $(document).on('click', function (e) {
        var $target = $(e.target);
        if (!$target.closest('.jump-to-page').length &&
            window.reviewJumper.is(":visible")) {
            window.reviewJumper.detach();
        }
    });

    $('.pagination').on('change', '.jump-to-page select', function () {
        var selectedValue = $(this).val();
        var $pagination = $(this).closest('.pagination');

        $('a[data-page="' + selectedValue + '"]', $pagination).trigger('click');
        window.reviewJumper.detach();
    });

});

function updateTotalRatingAvg($reviewListingWidget = null) {
    if($reviewListingWidget) {
        let reviewListingAvg =  convertNumberToWord($reviewListingWidget.attr("data-ratingAvg"));
        if(!reviewListingAvg) {
            console.error("null average value");
            return;
        }
        // show current rating avg
        $reviewListingWidget.find(".averageRating").attr("src", `/images/star-${reviewListingAvg}.png`);
    }
    
}
function convertNumberToWord(number = null) {
    if(!number) {
        return null;
    }
    let wholeNumber = Math.trunc(number);
    let decimal = number - wholeNumber;
    let decimalWord = "";
    if(decimal != 0) {
        decimalWord = "-half";
    }
    let wholeNumberWord = wholeNumber == 5 ?  "five" : wholeNumber == 4 ? "four" : 
    wholeNumber == 3 ? "three" : wholeNumber == 2 ? "two" : wholeNumber == 1 ? "one" : null;
    return `${wholeNumberWord}${decimalWord}`;
}
function loadMore(scrollToReview = null) {
    let $list = $("#review-list");
    let parentElement = $list.closest(".review-listing");
    let totalCountElm = parentElement.find("span.countTotal");
    let currLocationElm = parentElement.find("span.location");
    let newLocation = parentElement.find("[name='state']").val();
    let inElm =  parentElement.find("span.in");
    let page_num = parseInt($list.data("page"));
    let api_url = "/api/reviews/?page=" + page_num;

    if (scrollToReview != null) {
        api_url += "&showReview=" + scrollToReview;
    } else {
        if ($list.data('state') != "")
            api_url += "&state=" + $list.data('state');

        if ($list.data('rating') != "")
            api_url += "&rating=" + $list.data('rating');

        if ($list.data('market') != "")
            api_url += "&market=" + $list.data('market');
    }

    // for franchisee / FZLP
    if ($list.data('satellitecode')) {
        api_url += "&satelliteCode=" + $list.data('satellitecode');
    }

    let verifiedSellerBadge = '<img alt="Verified Seller" src="/images/WBUH-verified-seller-badge.svg" class="verifiedSellerBadge">';
    if ($('.reviewList--hva').length) {
        verifiedSellerBadge = '<img alt="Verified Seller" src="/images/HVA-verified-seller-badge.svg" class="verifiedSellerBadge verifiedSellerBadge--hva">';
    }

    $.get(api_url, function (response) {
        if ($list.data('resetHtml')) {
            $list.html('').data('resetHtml', false);
        }

        // dynamically set the total count and location
        if(response.totalCount) {
            totalCountElm.html(`${Number(response.totalCount).toLocaleString('en-US')}`);
        }
        
        if(newLocation !== currLocationElm.text()) {
            if(newLocation === "" || newLocation == null) {
                inElm.addClass("hide");
                newLocation = "Nationwide";
            } 
            else {
                inElm.removeClass("hide");
            }
            currLocationElm.html(newLocation);
        }
        // get the count for each rating and set the counts
        if (response.ratingCounts) {
            $('.review-summary button.summary-row').each(function(index) {
                let ratingCount = response.ratingCounts[4 - index] || 0;
                let percentage = 0;
                if(response.totalCount && response.totalCount != 0) {
                    percentage = (ratingCount / response.totalCount) * 100;
                }
                $(this).find(".inner").width(`${percentage}%`);
                // if not disabled and the count is 0 then disable it
                if(ratingCount == 0) {
                    if(!$(this).prop('disabled')) {
                        $(this).prop('disabled', true);
                    }
                }
                else if(!$(this).hasClass('filtered')) {
                    if($(this).prop('disabled')) {
                        $(this).prop('disabled', false);
                    } 
                }
                $(this).find('.count').text(`${Number(ratingCount).toLocaleString('en-US')}`);
            });
        }
        if(response.ratingAverage) {
            parentElement.attr("data-ratingAvg", response.ratingAverage);
            updateTotalRatingAvg(parentElement);
        }
        if (response.reviews.length > 0) {
            $.each(response.reviews, function () {
                let locStr = '';
                if (this.city.length || this.state.length) {
                    locStr = '(' + (this.city.length ? this.city + ', ' : '') + this.state + ')';
                }

                $list.append(
                    `<li id="review-${this.reviewID}"> 
                        <div class="rating"><img src="/images/star-${this.ratingName}.png">${verifiedSellerBadge}</div> 
                        <div class="review-content">${this.question2Answer}</div> 
                        <div class="review-source">${this.firstName} ${this.lastName.charAt(0)}. ${locStr} &bull;&nbsp;(${getFormattedDate(new Date(this.datePublished))})</div>
                    </li>`
                );

                // if the quote is empty, then we don't need to show the quote icon
                if (this.question2Answer.length <= 1) {
                    $('li#review-' + this.reviewID).addClass('no-quote');
                }
            });
            if (!$('.reviewList__verifiedSellerPanel').length) {
                let $listItems = $list.find('li');
                let verifiedSellerPanel = `
                <li class="reviewList__verifiedSellerPanel no-quote">
                    <p>${verifiedSellerBadge}</p>
                    ${window.verifiedSellerPanelContent}
                </li>`;
                if ($listItems.length >= 2) {
                    $listItems.eq(1).after(verifiedSellerPanel);
                } else {
                    $list.append(verifiedSellerPanel);
                }
            }
            if (scrollToReview != null) {
                // smooth scroll to review location
                let headerHeight = 0;
                if ($('#header-form').length) {
                    headerHeight = $('#header-form').outerHeight();
                }

                $('html, body').animate({
                    scrollTop: $('#review-' + scrollToReview).offset().top - headerHeight - 20
                }, 900, 'swing');
            }

            // reset 'no reviews' message and hidden pagination, if necessary
            $('.reviewList__msg').remove();
            $('#review-pagination').removeClass('disabled');
            reInitPagination(page_num, response.pageCount);
        }
        else if (page_num === 1) {
            $('.reviewList__msg').remove();
            let starRating = $('.review-listing [name="rating"]').val();
            if(starRating) {
                $list.before(`<p class="reviewList__msg">There are no ${starRating} star reviews. Please filter by a different rating.</p>`);
            } else {
                $list.before(`<p class="reviewList__msg">There are no reviews. Please filter by a different state.</p>`);
            }
            $('#review-pagination').addClass('hide');
        }
        // add verifiedSellerPanel even with 0 reviews only on the reviews widget 
        // that isn't present on the franchisee page - check if there's a 
        // class only present on the reviews widget not on the franchisee page
        if ($("#review-list").attr("data-widget") != null && response.reviews.length == 0 && !$('.reviewList__verifiedSellerPanel').length) {
            let verifiedSellerPanel = `
            <li class="reviewList__verifiedSellerPanel no-quote">
                <p>${verifiedSellerBadge}</p>
                ${window.verifiedSellerPanelContent}
            </li>`;
            $list.append(verifiedSellerPanel);
        }
    });
}

function getFormattedDate(date) {
    let year = date.getFullYear();
    let month = (1 + date.getMonth()).toString().padStart(2, '0');
    let day = date.getDate().toString().padStart(2, '0');

    return month + '/' + day + '/' + year;
}

function reInitPagination(selectedPage, totalPages) {
    // update jump-to-page options in the detached reviewJumper element
    if (typeof (totalPages) != 'undefined' && window.reviewJumper) {
        const $jumpSelect = window.reviewJumper.find('select');

        if ($jumpSelect.length) {
            $jumpSelect.empty();

            for (let i = 1; i <= totalPages; i++) {
                const $option = $('<option>', {
                    value: i,
                    text: i
                });

                // select current page
                if (i === selectedPage) {
                    $option.attr('selected', 'selected');
                    $option.addClass('selected-option');
                }

                $jumpSelect.append($option);
            }
        }
    }

    if (typeof (selectedPage) != 'undefined') {
        $('#review-pagination .pagination a').removeClass('active');
        $('#review-pagination .pagination a[data-page="' + selectedPage + '"]').addClass('active');
    }

    // hide/show pagination based on how many pages 
    // or whether user is on first or last active page
    if (selectedPage == totalPages) {
        $('.next').addClass('disabled').prop("disabled", true);
    } else {
        $('.next').removeClass('disabled').removeAttr("disabled");
    }

    if (selectedPage == 1) {
        $('.previous').addClass('disabled').prop("disabled", true);
    } else {
        $('.previous').removeClass('disabled').removeAttr("disabled");
    }

    if (totalPages == 1) {
        $('#review-pagination').addClass('hide');
    } else {
        $('#review-pagination').removeClass('hide');
    }

    // too many page numbers? remove some and replace with ellipses
    $('#review-pagination .pagination').each(function () {
        if ($('li', this).length > 8) {
            if (typeof (totalPages) != 'undefined')
                $(this).elidePages(totalPages);
            else
                $(this).elidePages();
        }
    });
}

$.fn.elidePages = function (totalPages) {
    $('.el-li', this).remove();
    var activePageNum = parseInt($('.active', this).data('page'));
    var $pageLIs = $('li', this).slice(1, -1);

    $pageLIs.hide();
    let ellipsisHtml = `
    <li class="el-li">
        <a href="javascript:;" class="ellip">
            <img alt="open jump to page dialog" src="/images/page-ellipsis.svg" />
        </a>
    </li>`;

    // hide page numbers that may not be used because of filter states
    if (typeof (totalPages) != 'undefined')
    {
        $pageLIs = $pageLIs.slice(0, totalPages);
        if(totalPages < 8) {
            $pageLIs.show();
            return;
        }
    }

    let isXXLarge = window.Foundation.mediaQuery.MediaQuery.is("xxlarge");
    let isXLarge = window.Foundation.mediaQuery.MediaQuery.is("xlarge");
    let isDesktop = window.Foundation.mediaQuery.MediaQuery.is("desktop");
    let isLarge  =  window.Foundation.mediaQuery.MediaQuery.is("large");
    let isMobile = window.Foundation.mediaQuery.MediaQuery.is("medium");

    let leftHandRange = 0;
    let rightHandRange = 0;

    // the following values are made with the assumption that the active number is 
    // on the left hand-side
    if(isXXLarge) {
        rightHandRange = 4;
        leftHandRange = 4;
    }
    else if(isXLarge){
        rightHandRange = 3;
    }  
    else if(isDesktop) {
        rightHandRange = 2;
    } else {
        rightHandRange = 1;
    }
    
    if(isXLarge || isDesktop){
        leftHandRange = 3;
    }  
    else if(isLarge){
        leftHandRange = 3;
    }
    else if(isMobile) {
        leftHandRange = 2;
    }  

    // if the active page number is more on the right side than the left side
    // swap left and right ranges
    if(activePageNum >= $pageLIs.length - leftHandRange) {
        if(isLarge || isDesktop || isMobile) {
            // swap the left and right hand ranges
            let tmp = leftHandRange;
            leftHandRange = rightHandRange;
            rightHandRange = tmp;
        }
    }
    if(activePageNum <= leftHandRange || activePageNum > $pageLIs.length - rightHandRange) {
        $pageLIs.slice(0, leftHandRange).show();
        $pageLIs.slice(-1 * rightHandRange).show();
        $pageLIs.eq(leftHandRange).after(ellipsisHtml);
    }
    else { // otherwise two ellipses surrounding the selected page and two on either side
        $pageLIs.eq(0).show();
        $pageLIs.eq(-1).show();
        // check all screensizes are appropriately slice the middle
        if (isXXLarge) {
            $pageLIs.slice(activePageNum - 2, activePageNum + 3).show();
            $pageLIs.eq(activePageNum - 3).after(ellipsisHtml);
            $pageLIs.eq(activePageNum + 2).after(ellipsisHtml);
        } else if (isXLarge || isDesktop) {
            $pageLIs.slice(activePageNum - 1, activePageNum + 2).show();
            $pageLIs.eq(activePageNum - 2).after(ellipsisHtml);
            $pageLIs.eq(activePageNum + 1).after(ellipsisHtml);
        } else if (isLarge) {
            $pageLIs.slice(activePageNum - 1, activePageNum + 2).show();
            $pageLIs.eq(activePageNum - 2).after(ellipsisHtml);
            $pageLIs.eq(activePageNum + 1).after(ellipsisHtml);
        } else {
            $pageLIs.slice(activePageNum - 1, activePageNum).show();
            $pageLIs.eq(activePageNum - 2).after(ellipsisHtml);
            $pageLIs.eq(activePageNum).after(ellipsisHtml);
        }

    }
};